export abstract class SupportModel {
    // ...
}
